import {
  FETCH_APP_SETTINGS_COMPLETE_FAILURE,
  FETCH_APP_SETTINGS_COMPLETE_REQUEST,
  FETCH_APP_SETTINGS_COMPLETE_SUCCESS,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST,
  FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS,
  FETCH_APP_SETTINGS_FAILURE,
  FETCH_APP_SETTINGS_REQUEST,
  FETCH_APP_SETTINGS_SUCCESS,
  SAVE_APP_SETTINGS_FAILURE,
  SAVE_APP_SETTINGS_REQUEST,
  SAVE_APP_SETTINGS_SUCCESS,
} from '../../reducers/types';
import {
  getAppSettingsCompleteByIdService,
  getSimpleAppSettingsListService,
  getAppSettingsService,
  saveAppSettingsService,
} from '../../services/appCmsServices/AppSettingsService';

export const getAppSettingsAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_APP_SETTINGS_REQUEST,
      });
      const response = await dispatch(getAppSettingsService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_APP_SETTINGS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_APP_SETTINGS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_APP_SETTINGS_FAILURE,
      });
    }
  };
};

export const getAppSettingsCompleteByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_APP_SETTINGS_COMPLETE_REQUEST,
      });
      const response = await dispatch(getAppSettingsCompleteByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_APP_SETTINGS_COMPLETE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_APP_SETTINGS_COMPLETE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_APP_SETTINGS_COMPLETE_FAILURE,
      });
    }
  };
};

export const getSimpleAppSettingsListAction = (idList, all) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_REQUEST,
      });
      const response = await dispatch(
        getSimpleAppSettingsListService(idList, all),
      );
      if (response.status === 200) {
        dispatch({
          type: FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_SIMPLE_APP_SETTINGS_LIST_PDF_FAILURE,
      });
    }
  };
};

export const saveAppSettingsAction = data => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_APP_SETTINGS_REQUEST,
      });
      const response = await dispatch(saveAppSettingsService(data));
      if (response.status === 200) {
        dispatch({
          type: SAVE_APP_SETTINGS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: SAVE_APP_SETTINGS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_APP_SETTINGS_FAILURE,
      });
    }
  };
};
